import { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toPng } from 'html-to-image';
import { closeModal } from 'state/modal/modalSlice';
import { getFenceGroupDetails } from 'state/fence/fenceSelector';
import FenceElements from 'components/features/FenceCanvas/FenceElements/FenceElements';
import ModalBase from 'components/common/ModalBase/ModalBase';
import ButtonBase from 'components/common/ButtonBase/ButtonBase';
import LoaderBase from 'components/common/LoaderBase/LoaderBase';
import style from './AppModals.module.scss';

const ModalFullView = ({ createImage = false, className = '', onCreateImage = () => {} }) => {
  const fenceDesignRef = useRef();
  const dispatch = useDispatch();
  const fence = useSelector((state) => state.fence);
  const fenceGroups = useSelector(getFenceGroupDetails);
  const [loading, setLoading] = useState(false);

  const cancelHandler = () => {
    dispatch(closeModal());
  };

  useEffect(() => {
    const createImageAsync = async () => {
      try {
        const dataUrl = await toPng(fenceDesignRef.current, {
          backgroundColor: '#ffffff',
          pixelRatio: 1,
          skipAutoScale: true,
        });

        onCreateImage(dataUrl);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    if (loading) {
      createImageAsync();
    }
  }, [loading]);

  useEffect(() => {
    if (createImage) {
      setLoading(true);
    }
  }, [createImage]);

  return (
    <>
      <ModalBase size="full" className={className}>
        {!createImage && (
          <ButtonBase className={style['btn-close']} onClick={cancelHandler}>
            <i className="material-symbols-outlined">close</i>
          </ButtonBase>
        )}

        <div className={style.fenceDesign} ref={fenceDesignRef}>
          {fenceGroups.map((group, i) => (
            <div key={group.id} className="pb-lg">
              <h3 className="mb-xs">{i + 1}. oldal</h3>

              <p className="text-sm">
                Kerítés / telek hossza: {group.totalFenceWidth} cm / {group.settings.maxWidth} cm
              </p>

              <FenceElements fence={fence} fenceGroupDetails={group} />
            </div>
          ))}
        </div>
      </ModalBase>
      {loading && <LoaderBase />}
    </>
  );
};

export default ModalFullView;
